import BaseTextInputEditor from '../BaseTextInputEditor';

export class NumberInputEditor extends BaseTextInputEditor {
  getCellCustomStyle(): string {
    return 'custom-number-editor';
  }
}
